const routers = [
    {
        path: '/icon',
        name: 'icon',
        meta: {
            exp: '图标',
            requireAuth: false
        },
        component: () => import('@/views/icon/index.vue'),
    }
]
export default routers


